import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = "h-4 w-4", className = "" }) => {
  const full = Math.round(value);
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${value} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={`${size} ${i <= full ? "fill-ochre text-ochre" : "fill-transparent text-border"}`}
        />
      ))}
    </div>
  );
};

export const StarInput = ({ value, onChange }) => (
  <div className="inline-flex items-center gap-1">
    {[1, 2, 3, 4, 5].map((i) => (
      <button
        key={i}
        type="button"
        data-testid={`star-${i}`}
        onClick={() => onChange(i)}
        className="transition-transform hover:scale-110"
        aria-label={`Rate ${i} stars`}
      >
        <Star className={`h-7 w-7 ${i <= value ? "fill-ochre text-ochre" : "fill-transparent text-border"}`} />
      </button>
    ))}
  </div>
);
